<template>
<div>
  <b-navbar  type="dark" variant="dark" fixed="bottom">
    <b-navbar-nav style="width: 100%" fill>
      <b-nav-item to="/dashboard" exact><feather type="list"></feather>二手</b-nav-item>
      <b-nav-item href="#" @click.prevent="onLogout"><feather type="settings"></feather>登出</b-nav-item>
    </b-navbar-nav>

  </b-navbar>
</div>
</template>

<style scoped>
a.router-link-exact-active {
  color: lightBlue !important;
}

</style>

<script>
import api from "../services/UserService";


    export default {
        name: 'TopMenu',
        props: [],
        components: {
        },
        data() {
          return {
          }
        },
        methods: {
          onLogout() {
            api
              .post("/api/logout")
              .then(response => {
                console.log(response.data);
              })
              .catch(error => {
                console.log(error);
              })
              .then(() => {
                this.$store.commit("mutateSessionLogout");
                this.$router.push({ name: "Login" });
              });
          }
        },
        mounted() {
        }
    }
</script>